<template>
  <div class="sidebar">
    <el-card :header="['时间地点','Time and place'][$language]"  class="box">
      <div class="label-text">
        <div class="label">{{['始时间','Start time : '][$language]}}</div>
        <div class="text">{{ $event.StartDate }}</div>
      </div>
      <div class="label-text">
        <div class="label">{{['结束时间','End time : '][$language]}}</div>
        <div class="text">{{ $event.EndDate }}</div>
      </div>
      <div class="label-text">{{ $event.Address }}</div>
    </el-card>
    <el-card :header="['主办信息','Organizer'][$language]"  class="box">
      <div class="label-text">{{ $event.Organizer }}</div>
      <div class="label-text">
        <div class="label">{{['联系人：','Contact Person : '][$language]}}</div>
        <div class="text">{{ $event.ContactPerson }}</div>
      </div>
      <div class="label-text">
        <div class="label">{{['电话：','Telephone : '][$language]}}</div>
        <div class="text">{{ $event.Telephone }}</div>
      </div>
      <div class="label-text">
        <div class="label">{{['邮箱：','Email : '][$language]}}</div>
        <div class="text">{{ $event.Email }}</div>
      </div>
    </el-card>
    <el-card :header="['活动二维码','QR code '][$language]" class="qr box">
      <img :src="qrcode" />
    </el-card>
    <el-card :header="['技术支持','Support '][$language]"  class="box">
      <div class="label-text">Eventmaster</div>
      <div class="label-text">
        <div class="label">{{['邮箱：','Email : '][$language]}}</div>
        <div class="text">service@dataleading.cn</div>
      </div>
      <div class="label-text">
        <div class="label">{{['网址：','Website : '][$language]}}</div>
        <div class="text">www.dataleading.cn</div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
  import { ref, inject,computed } from 'vue'
  
  import { useAppStore } from '@/store/modules/app'

  import { storeToRefs } from 'pinia'
  import { getUrlKey, removeUrlHashParameter } from '@/utils/'
  const { event, config } = storeToRefs(useAppStore())
  const $event = inject('$event')
  const $language=inject('$language')

  const qrcode=computed(() => {
    let v=getUrlKey('v')
    let i=getUrlKey('i')
    let url=config.value.app.host+'/app/#/?'
    if(v){
      url+='v='+v
    }
    if(i){
      url+='i='+i
    }
    return `http://www.dataleading.cn/barcode/img.ashx?type=2d&text=${encodeURIComponent(url)}`
  })
</script>

<style lang="scss" scoped>
  .el-card {
    &:last-child {
      margin-bottom: 0 !important;
    }
    &.qr {
      :deep() {
        .el-card__body {
          padding: 0;
          img {
            width: 100%;
            max-width: 250px;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .label-text {
    color: #000;
    :deep() {
      .text {
        color: #000;
      }
    }
  }
</style>
